export default "__VITE_ASSET__CYj$o1UF__"